import template from './loansRepaymentLoanInfo.html';
import controller from './loansRepaymentLoanInfo.controller';
import './loansRepaymentLoanInfo.scss';

let loansRepaymentLoanInfoComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansRepaymentLoanInfoComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentLoanInfo/loansRepaymentLoanInfo.component.js